import React from "react";
import "./About.scss";

export default function About(props) {
  return (
    <div className="about">
      <div className="about__contact">
        <img
          src="https://res.cloudinary.com/chudi/image/upload/v1580224912/kola.png"
          alt="Kola Potrait"
          className="about__image"
        />
        <h1 className="about__contact__prompt">Contact me</h1>
        <p className="about__contact__email"> kolapopoola4@gmail.com</p>

        <div className="about__contact__social">
          <a
            rel="noopener noreferrer"
            target="_blank"
            className="about__contact__link"
            href="https://twitter.com/_Kolaa"
          >
            <img
              src="https://res.cloudinary.com/chudi/image/upload/v1580227427/twitter.svg"
              alt="Twitter"
              className="about__contact__icon"
            />
          </a>

          <a
            rel="noopener noreferrer"
            target="_blank"
            className="about__contact__link"
            href="https://dribbble.com/_Kolaa"
          >
            <img
              src="https://res.cloudinary.com/chudi/image/upload/v1580227427/dribbble.svg"
              alt="Dribble"
              className="about__contact__icon"
            />
          </a>

          <a
            rel="noopener noreferrer"
            target="_blank"
            className="about__contact__link"
            href="https://medium.com/@ebaandsoup"
          >
            <img
              src="https://res.cloudinary.com/chudi/image/upload/v1580227427/medium.svg"
              alt="Medium"
              className="about__contact__icon"
            />
          </a>

          <a
            rel="noopener noreferrer"
            target="_blank"
            className="about__contact__link"
            href="https://www.behance.net/kolapopool1e4a"
          >
            <img
              src="https://res.cloudinary.com/chudi/image/upload/v1580227427/behance.svg"
              alt="Behaance"
              className="about__contact__icon"
            />
          </a>
        </div>
      </div>

      <div className="about__details">
        <h1 className="about__introduction">My name is Kolawole...</h1>

        <div className="about__copy">
          <p className="about__copy__paragraph">
            I’m a product designer based in Lagos, Nigeria. I currently work at
            <a
              className="about__copy__link"
              href="https://max.ng"
              rel="noopener noreferrer"
              target="_blank"
            >
              {" "}
              MAX.NG{" "}
            </a>{" "}
            with some really talented people, solving transportation problems in
            Africa.
          </p>
          <p className="about__copy__paragraph">
            Before joining MAX I worked at{" "}
            <a
              className="about__copy__link"
              href="https://fieldinsight.co"
              rel="noopener noreferrer"
              target="_blank"
            >
              {" "}
              fieldinsight.co{" "}
            </a>{" "}
            - A logistics company built to strengthen companies bonds with their
            customers with a platform that works online and offline that helps
            your team on the field.
          </p>
          <p className="about__copy__paragraph">
            My journey in design has been a very interesting one, I’ve been
            opportuned to work with great minds and very talented people working
            different roles such as; graphics designer, UX design intern, UI/UX
            designer. Finished university in 2018 with a degree in Computer
            Science.
          </p>
          <p className="about__copy__paragraph">
            In my spare time, I write about sports, I watch a lot of sports and
            I play video games.
          </p>

          <p className="about__copy__paragraph">
            I’m currently available for any design gigs, if you’d like to build
            something groundbreaking shoot me a mail at{" "}
            <a
              className="about__copy__link"
              href="mailto:kolapopoola4@gmail.com"
            >
              {" "}
              kolapopoola4@gmail.com
            </a>{" "}
            :)
          </p>
        </div>
      </div>
    </div>
  );
}
